export default "__VITE_ASSET__BskK8q2t__"